// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import colors from "vuetify/util/colors";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  rtl: true,
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: colors.blue.darken4,
          secondary: colors.blue.lighten1,
          ora1: colors.orange.lighten2,
          ora2: colors.orange.darken3,
        },
      },
    },
  },
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
